<template>
  <div>
    <TempPopup />
    <div id="container" class="library_st_detail grid-container">
      <Sidebar
        @bookshelfChanged="resetSelfbook"
        @default-books="defaultBooks"
      />
      <Subbar
        ref="subbar"
        class="sub_bar_custom"
        @sort="sortTable"
        @reset-search="resetSelfbook"
        @show-all-books="loadAllBooks"
        @default-books="defaultBooks"
        @books-added="fetchBookTypes"
        @filter-refresh="refreshFilter"
      />
      <div v-if="!isBookshelfLoading" class="section full">
        <div class="search_filter">
          <div class="self_search_wrap">
            <input
              v-model="selfbook"
              type="text"
              class="input_search"
              placeholder="도서명, 저자명으로 검색"
              @keydown="onKeyDown"
            />
            <i class="ic_search" @click="selfSearch">
              <img
                src="@/assets/images/self_book/ic_search.png"
                alt="내서재 검색"
              />
            </i>
          </div>
          <div ref="filter" class="filter">
            <div
              v-if="
                !isBookshelfLoading &&
                getCurrentBookshelfBooks &&
                getCurrentBookshelfBooks.length > 0 &&
                hasMultipleBookTypes
              "
              class="btn"
              @click="toggleFilterList"
            >
              <span v-show="isTxtVisible" class="txt">
                필터
                <span v-show="isFilterNumVisible" class="filter_num">
                  {{ selectedFilterTypes.length }}
                </span>
              </span>
              <i v-show="isTxtVisible">
                <img src="@/assets/images/self_book/filter.png" alt="필터" />
              </i>
            </div>
            <ul v-show="isFilterListVisible" class="filter_list">
              <li v-if="bookTypes.hasPmt">
                <input
                  id="purchase"
                  v-model="filters.purchase"
                  type="checkbox"
                  @click="preventLastUncheck"
                />
                <label for="purchase">구매도서</label>
              </li>
              <li v-if="bookTypes.hasPrs">
                <input
                  id="freebie"
                  v-model="filters.freebie"
                  type="checkbox"
                  @click="preventLastUncheck"
                />
                <label for="freebie">증정본</label>
              </li>
              <li v-if="bookTypes.hasCpn">
                <input
                  id="trial"
                  v-model="filters.trial"
                  type="checkbox"
                  @click="preventLastUncheck"
                />
                <label for="trial">체험판</label>
              </li>
              <li v-if="bookTypes.hasGft">
                <input
                  id="received_gift"
                  v-model="filters.receivedGift"
                  type="checkbox"
                  @click="preventLastUncheck"
                />
                <label for="received_gift">선물</label>
              </li>
              <li v-if="bookTypes.hasExpired">
                <input
                  id="expired"
                  v-model="filters.expired"
                  type="checkbox"
                  @click="preventLastUncheck"
                />
                <label for="expired">기간 만료 도서</label>
              </li>
              <li class="ment">
                <img src="@/assets/images/feel.png" alt="" />
                최소 1개 필수 선택
              </li>
            </ul>
          </div>
        </div>

        <div
          v-if="staticInput && getCurrentBookshelfBooks.length !== 0"
          class="search_result"
        >
          '{{ staticInput }}' 검색결과 {{ searchResultCount }}
        </div>
        <div class="inner">
          <div class="eplist item_columns_grid">
            <BookTable
              ref="booktable"
              :staticInput="staticInput"
              :activeFilters="selectedFilterTypes"
              :isAddingBooks="$refs.subbar && $refs.subbar.isAddingBooks"
              @reset-search="resetSelfbook"
              @show-all-books="loadAllBooks"
              @default-books="fetchBookTypes"
              @bookshelfChanged="test"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- ERROR MODAL -->
    <transition name="modal-fade">
      <Modal v-if="showErrorModal">
        <div v-on-clickaway="returnRoute" class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt ly_alert">
            <div class="ly_inner">
              <p>{{ errorMessage }}</p>
              <div class="btnWrap">
                <button class="box_btn" @click="returnRoute">
                  <span class="an_t">확인</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import Sidebar from '@/components/library/Sidebar'
import Subbar from '@/components/library/Subbar'
import BookTable from '@/components/library/BookTable'
import TempPopup from '@/components/popup/TempPopup.vue'
import { mapGetters } from 'vuex'
import store from '@/store'
import {
  BOOKSHELF_GET_LIST,
  BOOKSHELF_SET_CURRENT, // 책장로드
  BOOKSHELF_BOOK_GET_LIST, // 책로드
  UI_CLOSE_SIDEBAR,
  UI_SHOW_SIDEBAR,
  BOOKSHELF_BOOK_COUNT, // 검색결과 카운트
  BOOKSHELF_BOOK_FILTER // 검색필터 유무
} from '@/store/types'

export default {
  name: 'Library',
  components: {
    Sidebar,
    Subbar,
    BookTable,
    TempPopup
  },
  data() {
    return {
      newListName: '',
      activeFilter: '',
      total: 0,
      currentPage: 1,
      showErrorModal: false,
      selfbook: '', // 동적값
      staticInput: '', // 정적값
      searchResultCount: 0,
      filterList: [],
      isShowingAllBooks: false,
      originalBookshelfId: '',
      mountBooks: [],
      isFilterListVisible: false,
      initialFilters: {
        purchase: true,
        freebie: true,
        trial: true,
        receivedGift: true,
        expired: false
      },
      filters: {
        purchase: true,
        freebie: true,
        trial: true,
        receivedGift: true,
        expired: false
      },
      bookTypes: {
        hasPmt: true, // 구매도서
        hasPrs: true, // 증정본
        hasCpn: true, // 체험판
        hasGft: true, // 선물
        hasExpired: true // 기간 만료 도서
      },
      isAddingBooks: false,
      isUpdatingFilters: false,
      isLoadingBookshelf: false,
      fetchBookTypesTimer: null,
      isTxtVisible: true,
      isFilterNumVisible: false,
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentBookshelf',
      'getCurrentBookshelfBooks',
      'isBookshelfLoading',
      'getBookshelves',
      'isSidebarOpen',
      'getCurrentUser'
    ]),
    allBookFilter() {
      return this.getBookshelves.filter((book) => book.bookshelfTp === 'DBS')
    },
    selectedFilterTypes() {
      const selected = []
      if (this.filters.purchase) selected.push('PMT')
      if (this.filters.freebie) selected.push('PRS')
      if (this.filters.trial) selected.push('CPN')
      if (this.filters.receivedGift) selected.push('GFT')
      if (this.filters.expired) selected.push('EXPIRED')
      return selected
    },
    hasMultipleBookTypes() {
      let activeTypeCount = 0
      if (this.bookTypes.hasPmt) activeTypeCount++
      if (this.bookTypes.hasPrs) activeTypeCount++
      if (this.bookTypes.hasCpn) activeTypeCount++
      if (this.bookTypes.hasGft) activeTypeCount++
      if (this.bookTypes.hasExpired) activeTypeCount++
      return activeTypeCount >= 2
    }
  },
  watch: {
    selfbook(newValue) {
      if (newValue === '') {
        this.resetSelfbook()
        if (this.$refs.subbar && this.$refs.subbar.isAddingBooks) {
          this.loadBooksWithParams(this.allBookFilter[0].id)
        } else {
          this.handleFilterChange()
          this.updateSearchResultCount(this.getCurrentBookshelf.id)
        }
      }
    },
    filters: {
      handler() {
        if (!this.isUpdatingFilters) {
          this.handleFilterChange()
        }
      },
      deep: true
    },
    getCurrentBookshelf() {
      this.fetchBookTypes()
    },
    isFilterListVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          document.addEventListener('click', this.handleOutsideClick)
        })
      } else {
        document.removeEventListener('click', this.handleOutsideClick)
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      try {
        await store.dispatch(BOOKSHELF_GET_LIST)
        const bookshelves = store.getters.getBookshelves
        if (Array.isArray(bookshelves) && bookshelves.length > 0) {
          const firstBookshelfId = bookshelves[0].id
          store.commit(BOOKSHELF_SET_CURRENT, firstBookshelfId)

          if (to.params.id !== firstBookshelfId) {
            vm.$router.replace({
              name: 'library',
              params: { id: firstBookshelfId }
            })
          }
        } else {
          store.commit(BOOKSHELF_SET_CURRENT, '')
        }
      } catch (e) {
        store.commit(BOOKSHELF_SET_CURRENT, '')
      }
    })
  },
  created() {
    this.$root.$on('default-books', this.fetchBookTypes)
    this.$root.$on('books-added', this.fetchBookTypes)
  },
  beforeDestroy() {
    this.$root.$off('default-books', this.fetchBookTypes)
    this.$root.$off('books-added', this.fetchBookTypes)
    document.removeEventListener('click', this.handleOutsideClick)
  },
  async mounted() {
    if (this.getCurrentUser) {
      // 로그인된 경우 처리
    } else {
      this.$router.push({ name: 'login' })
    }
    this.$store.commit(UI_SHOW_SIDEBAR)
  },
  destroyed() {
    this.$store.commit(UI_CLOSE_SIDEBAR)
  },
  methods: {
    // 책 목록 로드 함수
    async loadBooksWithParams(bookshelfId, searchText = null) {
      const params = {
        bookshelfId: bookshelfId || '',
        filterList: this.selectedFilterTypes
      }
      if (searchText !== null) {
        params.searchTxt = searchText
      }
      await this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, params)
      return params
    },
    // 검색 결과 수 업데이트
    async updateSearchResultCount(bookshelfId, searchText = null) {
      const params = {
        bookshelfId: bookshelfId || ''
      }
      if (searchText !== null) {
        params.searchTxt = searchText
      } else if (this.staticInput) {
        params.searchTxt = this.staticInput
      }
      if (this.selectedFilterTypes.length > 0) {
        params.filterList = this.selectedFilterTypes
      }
      this.searchResultCount = await this.$store.dispatch(
        BOOKSHELF_BOOK_COUNT,
        params
      )
    },
    async selfSearch() {
      const bookshelfId =
        this.$refs.subbar && this.$refs.subbar.isAddingBooks
          ? this.allBookFilter[0].id
          : this.getCurrentBookshelf.id

      // 책 목록 로드
      await this.loadBooksWithParams(bookshelfId, this.selfbook)

      // 검색 결과 수 업데이트
      await this.updateSearchResultCount(bookshelfId, this.selfbook)
      if (this.searchResultCount === 1) {
        this.isTxtVisible = false
      }
    },

    async onKeyDown(event) {
      if (event.key === 'Enter') {
        this.staticInput = this.selfbook
        this.selfSearch()
      }
    },

    async handleFilterChange() {
      try {
        const isAddingBooksMode =
          this.$refs.subbar && this.$refs.subbar.isAddingBooks
        const bookshelfId = isAddingBooksMode
          ? this.allBookFilter[0].id
          : this.getCurrentBookshelf?.id || ''

        // 필터링된 도서 목록 가져오기
        await this.loadBooksWithParams(bookshelfId, this.staticInput)

        // 필터링 후 결과 카운트 업데이트
        if (this.staticInput) {
          await this.updateSearchResultCount(bookshelfId, this.staticInput)
        }
      } catch (error) {
        // console.error('필터링 중 오류 발생:', error)
      }
    },

    async loadAllBooks() {
      try {
        this.originalBookshelfId = this.getCurrentBookshelf?.id || ''
        this.isShowingAllBooks = true

        if (this.$refs.subbar) {
          this.$refs.subbar.isAddingBooks = true
        }

        if (this.allBookFilter && this.allBookFilter.length > 0) {
          const result = await this.$store.dispatch(BOOKSHELF_BOOK_FILTER, {
            bookshelfId: this.allBookFilter[0].id
          })

          if (result) {
            this.updateFiltersFromResult(result)
          }
        }

        // 필터링된 도서 목록 가져오기
        await this.loadBooksWithParams(
          this.allBookFilter[0].id,
          this.staticInput
        )
      } catch (error) {
        // console.error('전체 도서 로딩 중 오류 발생:', error)
      }
    },

    // 결과에서 필터 업데이트
    updateFiltersFromResult(result) {
      this.isUpdatingFilters = true
      this.bookTypes = result

      // 필터 상태 업데이트
      this.filters.purchase = result.hasPmt
      this.filters.freebie = result.hasPrs
      this.filters.trial = result.hasCpn
      this.filters.receivedGift = result.hasGft
      this.filters.expired = false // 기본값은 false로 설정

      this.$nextTick(() => {
        this.isUpdatingFilters = false
      })
    },

    async fetchBookTypes() {
      // 이미 실행 중인 타이머가 있으면 취소
      if (this.fetchBookTypesTimer) {
        clearTimeout(this.fetchBookTypesTimer)
      }

      // 필터 숫자 먼저 숨기기
      this.isFilterNumVisible = false

      // 새로운 타이머 설정 (100ms 이내에 다시 호출되면 이전 요청 취소)
      this.fetchBookTypesTimer = setTimeout(async () => {
        try {
          if (!this.getCurrentBookshelf || !this.getCurrentBookshelf.id) return

          const bookshelfId = this.getCurrentBookshelf.id
          this.isLoadingBookshelf = true

          const result = await this.$store.dispatch(BOOKSHELF_BOOK_FILTER, {
            bookshelfId
          })

          if (result) {
            this.isUpdatingFilters = true
            this.bookTypes = result

            // 북타입에 따라 필터값 설정
            this.filters.purchase = result.hasPmt
            this.filters.freebie = result.hasPrs
            this.filters.trial = result.hasCpn
            this.filters.receivedGift = result.hasGft
            this.filters.expired = false
            this.initialFilters = { ...this.filters }
            this.isFilterListVisible = false

            await this.loadBooksWithParams(bookshelfId, this.staticInput)

            this.isLoadingBookshelf = false
            this.$nextTick(() => {
              this.isUpdatingFilters = false
              this.isFilterNumVisible = true
            })
          } else {
            await this.loadBooksWithParams(bookshelfId)
            this.isFilterNumVisible = true
          }
        } catch (error) {
          this.isLoadingBookshelf = false
          this.isUpdatingFilters = false
          // console.error('도서 유형 정보 로드 오류:', error)
        }
      }, 100)
    },

    async defaultBooks() {
      const bookshelfId = this.getCurrentBookshelf?.id || ''
      this.resetFilters()
      await this.loadBooksWithParams(bookshelfId)
    },

    toggleErrorModal(errorMessage) {
      if (errorMessage) {
        this.errorMessage = errorMessage
      }
      this.showErrorModal = !this.showErrorModal
    },

    closeModal() {
      this.showErrorModal = false
    },

    returnRoute() {
      this.closeModal()
      this.$router.push({ name: 'store' })
    },

    sortTable(sort) {
      if (this.$refs.booktable) {
        this.$refs.booktable.paginate(1, sort)
      }
    },

    resetFilters() {
      this.isUpdatingFilters = true
      this.filters = { ...this.initialFilters }
      this.isFilterListVisible = false
      this.$nextTick(() => {
        this.isUpdatingFilters = false
      })
    },

    resetSelfbook() {
      this.selfbook = ''
      this.staticInput = ''
      this.isTxtVisible = true
      this.resetFilters()
      this.$store.dispatch(BOOKSHELF_BOOK_FILTER, this.getCurrentBookshelf.id)
    },

    test() {
      this.selfbook = ''
      this.staticInput = ''
      this.isTxtVisible = true
    },

    toggleFilterList() {
      this.isFilterListVisible = !this.isFilterListVisible

      // 필터 목록이 표시될 때만 필터 상태를 업데이트
      if (this.isFilterListVisible) {
        // 책 추가 모드인지 확인
        const isAddingBooksMode =
          this.$refs.subbar && this.$refs.subbar.isAddingBooks

        // 적절한 책장 ID 선택
        const bookshelfId = isAddingBooksMode
          ? this.allBookFilter[0].id
          : this.getCurrentBookshelf?.id || ''

        // 현재 필터 정보를 가져오기
        this.$store
          .dispatch(BOOKSHELF_BOOK_FILTER, { bookshelfId })
          .then((result) => {
            if (result) {
              this.isUpdatingFilters = true
              this.bookTypes = result
              const currentFilters = { ...this.filters }

              // 필터 상태 업데이트
              this.filters.purchase = this.bookTypes.hasPmt
                ? currentFilters.purchase
                : false
              this.filters.freebie = this.bookTypes.hasPrs
                ? currentFilters.freebie
                : false
              this.filters.trial = this.bookTypes.hasCpn
                ? currentFilters.trial
                : false
              this.filters.receivedGift = this.bookTypes.hasGft
                ? currentFilters.receivedGift
                : false
              this.filters.expired = this.bookTypes.hasExpired
                ? currentFilters.expired
                : false

              // 모든 필터가 false인 경우 기본값 설정
              const hasAnyFilter = Object.values(this.filters).some(
                (value) => value
              )
              if (!hasAnyFilter) {
                this.filters.purchase = this.bookTypes.hasPmt
                this.filters.freebie = this.bookTypes.hasPrs
                this.filters.trial = this.bookTypes.hasCpn
                this.filters.receivedGift = this.bookTypes.hasGft
                this.filters.expired = false
              }

              this.$nextTick(() => {
                this.isUpdatingFilters = false
              })
            }
          })
      }
    },

    handleOutsideClick(event) {
      if (
        this.isFilterListVisible &&
        this.$refs.filter &&
        !this.$refs.filter.contains(event.target)
      ) {
        this.isFilterListVisible = false
      }
    },

    preventLastUncheck(event) {
      const isChecked = event.target.checked
      if (!isChecked) {
        // 체크된 체크박스 개수 계산
        const checkboxes = document.querySelectorAll(
          '.filter_list input[type="checkbox"]'
        )
        const checkedCount = Array.from(checkboxes).filter((cb) => cb.checked)
          .length

        if (checkedCount === 0) {
          event.preventDefault()
          return false
        }
      }
    },

    refreshFilter() {
      this.isTxtVisible = false
      this.isFilterNumVisible = false

      setTimeout(() => {
        this.isTxtVisible = true
        setTimeout(() => {
          this.isFilterNumVisible = true
        }, 100)
      }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>
.section.full {
  height: 100%;
}
.aside_snb {
  width: calc(50vw - (var(--scrollbar-width) / 2) - 560px);
  min-width: 230px;
  max-width: 400px;
}
.flex_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sub_bar_custom,
.section {
  max-width: 1120px;
}
.section {
  background: #f0f5fa;
  width: 100%;
}
.ly_inner {
  p {
    text-align: center;
    padding-bottom: 24px;
  }
  .btnWrap {
    text-align: center;
  }
}
.box_btn.line {
  height: auto;
  padding: 8px 16px;
  font-family: Noto Sans KR;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.03em;
}
/* 내서재 검색 */
.self_search_wrap {
  position: relative;
  width: 240px;
  .input_search {
    width: 100%;
    height: 40px;
    padding: 0 40px 0 15px;
    border: 1px solid #d5d5d5;
    border-radius: 8px;
    font-size: 15px;
    outline: none;
  }
  .ic_search {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
.search_result {
  display: inline-block;
  margin: 20px 0 0 24px;
  font-size: 17px;
}
.search_filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 90px 0 24px;
}
.filter {
  position: relative;
  user-select: none;
}
.filter_list {
  position: absolute;
  top: 36px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  width: 185px;
  padding: 15px 10px 15px 25px;
  background-color: #f0f5fa;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(34, 34, 34, 0.12);
  input {
    display: none;
    &:checked + label {
      &::before {
        background: url('../../assets/images/checkbox_on.png') no-repeat;
      }
    }
  }
  label {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 18px 0;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    color: #000;
    &::before {
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      background: url('../../assets/images/checkbox_off.png') no-repeat;
    }
  }
}
.filter {
  color: #155d81;
  .txt {
    font-weight: 400;
    color: #777;
    .filter_num {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-left: 3px;
      line-height: 20px;
      border-radius: 100%;
      background: #777777;
      text-align: center;
      color: #fff;
    }
  }
}
.btn {
  display: flex;
  align-items: center;
  gap: 9px;
  height: 35px;
  font-family: 'pretendard-medium';
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  &.edit_shelf {
    padding: 0 12px;
    background: #155d81;
    font-weight: 400;
    color: #fff;
    &::before {
      content: '+';
      line-height: 15px;
      font-size: 15px;
    }
  }
  i {
    display: inline-table;
    width: 25px;
    height: 25px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.ment {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px;
  font-size: 11px;
  line-height: normal;
  letter-spacing: 0.1px;
  color: #777;
  img {
    width: 15px;
    height: 15px;
  }
}
@media (min-width: 1024px) {
  #container.grid-container {
    grid-template-columns: minmax(230px, calc(50vw - 560px)) 1fr;
    min-height: 1050px;
    .section {
      justify-self: start;
      margin: 0;
    }
  }
  .sub_bar_custom {
    max-width: 1060px;
  }
}
@media (max-width: 1024px) {
  .section {
    padding: 0 34px;
  }
  .search_filter {
    padding: 5px 90px 0 0px;
  }
}
@media (max-width: 768px) {
  .section {
    padding: 0 20px;
  }
  .self_search_wrap {
    margin: 0;
  }
  .search_filter {
    padding: 30px 23px 0 0;
  }
  .filter_list {
    right: 0;
    left: auto;
    transform: translate(0);
  }
  .search_result {
    margin: 20px 0 0 0;
  }
}
@media (max-width: 480px) {
  .search_filter {
    padding: 0 0 0 0;
  }
  .btn {
    gap: 0;
  }
}
</style>
